/**************************************************
 * Nombre:       Tarjetas_Producto_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Producto_Variante = ({item, click, index}) => {


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, cursor: 'pointer'}}
            spacing={2}
        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={0}
                sx={{py: 1}}
            >


                <Grid container size={6}>
                    <Typography
                        sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
                </Grid>

                <Grid container size={6} sx={{mt: 0, justifyContent: 'flex-end'}}>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 12,
                            textOverflow: "ellipsis",

                        }}>{`Valor: ${formatoMonedaTabla(item.valor)}`}</Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto_Variante